@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-role-form
                [disabled]="_context.formMode === FormMode.Reading || _context.formContext.item.id === 0"
                [context]="_context.formContext"
                [role]="_context.formContext.item"
                (roleUpdated)="onRoleUpdated($event)"
                (canceled)="onCanceled($event)"></app-role-form>
        </mat-tab>
        @if (_context.formContext.item.id && _context.formContext.item.id !== 0) {
            <mat-tab label="Droits">
                <app-role-rights-form
                    [disabled]="_context.formMode === FormMode.Reading"
                    [context]="_context.formContext"
                    [role]="_context.formContext.item"
                    (roleRightsUpdated)="onRoleRightsUpdated($event)"
                    (roleRightsExported)="onRoleRightsExported()"
                    (roleRightsImported)="onRoleRightsImported()"
                    (canceled)="onCanceled($event)"></app-role-rights-form>
            </mat-tab>
        }
    </mat-tab-group>
}
